
import React, { memo } from 'react';
import { Handle, Position } from '@xyflow/react';
import { cn } from '@/lib/utils';

function EndNode({ data }: { data: any }) {
  return (
    <div className={cn(
      "px-4 py-2 shadow-md rounded-md border-2 border-red-500 bg-red-50",
      "min-w-[150px] text-center"
    )}>
      <Handle 
        type="target" 
        position={Position.Top} 
        className="w-3 h-3 bg-red-500" 
      />
      <div className="font-bold">{data.label}</div>
    </div>
  );
}

export default memo(EndNode);
